import { render } from "./ExcelIcon.vue?vue&type=template&id=6f897696"
import script from "./ExcelIcon.vue?vue&type=script&lang=js"
export * from "./ExcelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__